import classNames from 'classnames';
import React from 'react';
import {
	Link,
} from 'react-router5';

import poweredByConductorSvg from '../../../../images/powered-by-conductor.svg';
import certifiedPartnerConductorSvg from '../../../../images/certified-partner-conductor.svg';



export enum SiteLogoBadge {
	CertifiedPartner,
	PoweredByContentKing,
}

type Props = {
	/** Flag showing special badge when custom logo set */
	badge?: SiteLogoBadge,
	/** Possibility to set alt tag for custom logos */
	customLogoAlt?: string,
	/** Source path to custom logo */
	customLogoSrc?: string,
	/** External URL (e.g. Conductor app home) — when set, used instead of in-app router link */
	href?: string,
	routeName?: string,
	routeParams?: {},
};



const SiteLogo: React.FC<Props> = (props) => {
	const {
		badge,
		customLogoAlt,
		customLogoSrc,
		href,
		routeName,
		routeParams = {},
	} = props;

	const componentClasses = classNames({
		'site-logo': true,
		'site-logo--default': !customLogoSrc,
		'site-logo--custom': customLogoSrc,
	});

	let content = (
		<>Conductor</>
	);

	if (customLogoSrc) {
		content = (
			<span className="site-logo__container">
				<span className="site-logo__custom-logo">
					<img
						alt={customLogoAlt || 'Logo'}
						src={customLogoSrc}
						title="Conductor"
					/>
				</span>

				{badge === SiteLogoBadge.CertifiedPartner ? (
					<img
						alt="Conductor certified partner"
						className="site-logo__certified-partner-badge"
						src={certifiedPartnerConductorSvg}
					/>
				) : badge === SiteLogoBadge.PoweredByContentKing ? (
					<img
						alt="powered by Conductor"
						className="site-logo__powered-by-info"
						src={poweredByConductorSvg}
					/>
				) : null}
			</span>
		);
	}

	if (href) {
		return (
			<a
				className={componentClasses}
				href={href}
			>
				{content}
			</a>
		);
	}

	if (routeName) {
		return (
			<Link
				className={componentClasses}
				routeName={routeName}
				routeParams={routeParams}
			>
				{content}
			</Link>
		);
	}

	return (
		<div className={componentClasses}>
			{content}
		</div>
	);
};



export default SiteLogo;
